/**
 * NARA Tourism — Ilustraciones SVG marinas exclusivas
 * Usadas en empty states, decoraciones, animaciones y branding
 */
import React from 'react';
import { Box, keyframes } from '@mui/material';

// Animación de ola para entrada de cards (izquierda a derecha)
export const waveEntrance = keyframes`
  0% { opacity: 0; transform: translateX(-20px); }
  100% { opacity: 1; transform: translateX(0); }
`;

// Animación de ola suave (floating)
const waveFloat = keyframes`
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-3px); }
`;

// Loading spinner marino — ola animada
export const NaraLoader = ({ size = 48 }) => (
  <Box sx={{ width: size, height: size, mx: 'auto', animation: `${waveFloat} 1.5s ease-in-out infinite` }}>
    <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 24 Q10 18 16 24 Q22 30 28 24 Q34 18 40 24 Q44 28 48 24" stroke="#0891b2" strokeWidth="3" strokeLinecap="round" opacity="0.8">
        <animate attributeName="d" dur="1.2s" repeatCount="indefinite"
          values="M4 24 Q10 18 16 24 Q22 30 28 24 Q34 18 40 24 Q44 28 48 24;M4 24 Q10 30 16 24 Q22 18 28 24 Q34 30 40 24 Q44 18 48 24;M4 24 Q10 18 16 24 Q22 30 28 24 Q34 18 40 24 Q44 28 48 24"/>
      </path>
      <path d="M4 32 Q10 26 16 32 Q22 38 28 32 Q34 26 40 32 Q44 36 48 32" stroke="#06b6d4" strokeWidth="2" strokeLinecap="round" opacity="0.4">
        <animate attributeName="d" dur="1.5s" repeatCount="indefinite"
          values="M4 32 Q10 26 16 32 Q22 38 28 32 Q34 26 40 32 Q44 36 48 32;M4 32 Q10 38 16 32 Q22 26 28 32 Q34 38 40 32 Q44 26 48 32;M4 32 Q10 26 16 32 Q22 38 28 32 Q34 26 40 32 Q44 36 48 32"/>
      </path>
      <path d="M4 16 Q10 10 16 16 Q22 22 28 16 Q34 10 40 16 Q44 20 48 16" stroke="#22d3ee" strokeWidth="1.5" strokeLinecap="round" opacity="0.25">
        <animate attributeName="d" dur="1.8s" repeatCount="indefinite"
          values="M4 16 Q10 10 16 16 Q22 22 28 16 Q34 10 40 16 Q44 20 48 16;M4 16 Q10 22 16 16 Q22 10 28 16 Q34 22 40 16 Q44 10 48 16;M4 16 Q10 10 16 16 Q22 22 28 16 Q34 10 40 16 Q44 20 48 16"/>
      </path>
    </svg>
  </Box>
);

// Barquito sobre olas — para Salidas vacías
export const EmptyBoat = ({ size = 80 }) => (
  <Box sx={{ width: size, height: size, mx: 'auto', mb: 1.5 }}>
    <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 52 Q20 48 30 52 Q40 56 50 52 Q60 48 70 52" stroke="#0891b2" strokeWidth="2" strokeLinecap="round" opacity="0.3"/>
      <path d="M5 58 Q15 54 25 58 Q35 62 45 58 Q55 54 65 58 Q75 62 80 58" stroke="#0891b2" strokeWidth="1.5" strokeLinecap="round" opacity="0.15"/>
      <path d="M25 50 L40 24 L55 50 Z" fill="#0891b2" opacity="0.12"/>
      <path d="M38 26 L38 50" stroke="#0891b2" strokeWidth="2" opacity="0.25"/>
      <path d="M38 26 L52 38" stroke="#0891b2" strokeWidth="1.5" opacity="0.2"/>
      <path d="M20 50 Q30 46 40 50 Q50 46 60 50 L58 54 Q48 50 40 54 Q32 50 22 54 Z" fill="#0891b2" opacity="0.15"/>
      <circle cx="60" cy="18" r="6" fill="#f59e0b" opacity="0.15"/>
      <path d="M60 12 L60 8 M66 18 L70 18 M54 18 L50 18 M65 13 L68 10 M55 13 L52 10" stroke="#f59e0b" strokeWidth="1" strokeLinecap="round" opacity="0.15"/>
    </svg>
  </Box>
);

// Ticket con ola — para Reservaciones vacías
export const EmptyTicket = ({ size = 80 }) => (
  <Box sx={{ width: size, height: size, mx: 'auto', mb: 1.5 }}>
    <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="15" y="22" width="50" height="32" rx="4" fill="#0891b2" opacity="0.08" stroke="#0891b2" strokeWidth="1.5" opacity="0.2"/>
      <line x1="38" y1="22" x2="38" y2="54" stroke="#0891b2" strokeWidth="1" strokeDasharray="3 3" opacity="0.15"/>
      <circle cx="28" cy="34" r="3" fill="#0891b2" opacity="0.15"/>
      <line x1="22" y1="41" x2="34" y2="41" stroke="#0891b2" strokeWidth="1.5" strokeLinecap="round" opacity="0.12"/>
      <line x1="24" y1="45" x2="32" y2="45" stroke="#0891b2" strokeWidth="1" strokeLinecap="round" opacity="0.1"/>
      <path d="M44 32 L50 32 M44 37 L52 37 M44 42 L48 42" stroke="#0891b2" strokeWidth="1.5" strokeLinecap="round" opacity="0.15"/>
      <path d="M5 62 Q15 58 25 62 Q35 66 45 62 Q55 58 65 62 Q75 66 80 62" stroke="#0891b2" strokeWidth="2" strokeLinecap="round" opacity="0.2"/>
      <path d="M0 68 Q12 64 24 68 Q36 72 48 68 Q60 64 72 68 Q80 72 80 68" stroke="#06b6d4" strokeWidth="1.5" strokeLinecap="round" opacity="0.1"/>
    </svg>
  </Box>
);

// Palmera con playa — para Catálogo vacío
export const EmptyPalm = ({ size = 80 }) => (
  <Box sx={{ width: size, height: size, mx: 'auto', mb: 1.5 }}>
    <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M35 55 Q36 40 38 30" stroke="#059669" strokeWidth="2" strokeLinecap="round" opacity="0.25"/>
      <path d="M38 30 Q28 22 18 26" stroke="#059669" strokeWidth="1.5" strokeLinecap="round" opacity="0.2"/>
      <path d="M38 30 Q32 18 22 16" stroke="#059669" strokeWidth="1.5" strokeLinecap="round" opacity="0.2"/>
      <path d="M38 30 Q44 18 54 18" stroke="#059669" strokeWidth="1.5" strokeLinecap="round" opacity="0.2"/>
      <path d="M38 30 Q48 24 56 28" stroke="#059669" strokeWidth="1.5" strokeLinecap="round" opacity="0.2"/>
      <path d="M38 30 Q36 20 38 14" stroke="#059669" strokeWidth="1.5" strokeLinecap="round" opacity="0.2"/>
      <ellipse cx="40" cy="58" rx="22" ry="4" fill="#f59e0b" opacity="0.12"/>
      <path d="M5 64 Q15 60 25 64 Q35 68 45 64 Q55 60 65 64 Q75 68 80 64" stroke="#0891b2" strokeWidth="2" strokeLinecap="round" opacity="0.2"/>
      <path d="M0 70 Q12 66 24 70 Q36 74 48 70 Q60 66 72 70" stroke="#0891b2" strokeWidth="1.5" strokeLinecap="round" opacity="0.1"/>
    </svg>
  </Box>
);

// Persona con ola — para Usuarios vacío
export const EmptyUsers = ({ size = 80 }) => (
  <Box sx={{ width: size, height: size, mx: 'auto', mb: 1.5 }}>
    <svg viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="40" cy="28" r="8" fill="#0891b2" opacity="0.12" stroke="#0891b2" strokeWidth="1.5" opacity="0.2"/>
      <path d="M26 48 Q26 40 40 38 Q54 40 54 48" fill="#0891b2" opacity="0.08" stroke="#0891b2" strokeWidth="1.5" opacity="0.15"/>
      <circle cx="24" cy="32" r="5" fill="#06b6d4" opacity="0.08" stroke="#06b6d4" strokeWidth="1" opacity="0.12"/>
      <circle cx="56" cy="32" r="5" fill="#06b6d4" opacity="0.08" stroke="#06b6d4" strokeWidth="1" opacity="0.12"/>
      <path d="M5 60 Q15 56 25 60 Q35 64 45 60 Q55 56 65 60 Q75 64 80 60" stroke="#0891b2" strokeWidth="2" strokeLinecap="round" opacity="0.2"/>
      <path d="M0 66 Q12 62 24 66 Q36 70 48 66 Q60 62 72 66" stroke="#0891b2" strokeWidth="1.5" strokeLinecap="round" opacity="0.1"/>
    </svg>
  </Box>
);

// Olas decorativas para sidebar header
export const WavePattern = () => (
  <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 28, pointerEvents: 'none', overflow: 'hidden' }}>
    <svg viewBox="0 0 240 28" preserveAspectRatio="none" style={{ width: '100%', height: '100%' }}>
      <path d="M0 14 Q15 6 30 14 Q45 22 60 14 Q75 6 90 14 Q105 22 120 14 Q135 6 150 14 Q165 22 180 14 Q195 6 210 14 Q225 22 240 14 L240 28 L0 28 Z" fill="rgba(255,255,255,0.15)"/>
      <path d="M0 18 Q20 12 40 18 Q60 24 80 18 Q100 12 120 18 Q140 24 160 18 Q180 12 200 18 Q220 24 240 18 L240 28 L0 28 Z" fill="rgba(255,255,255,0.08)"/>
    </svg>
  </Box>
);

// Olas decorativas para login background
export const LoginWaves = () => (
  <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 180, pointerEvents: 'none', zIndex: 0 }}>
    <svg viewBox="0 0 1440 180" preserveAspectRatio="none" style={{ width: '100%', height: '100%' }}>
      <path d="M0 80 Q180 40 360 80 Q540 120 720 80 Q900 40 1080 80 Q1260 120 1440 80 L1440 180 L0 180 Z" fill="#0891b2" opacity="0.15"/>
      <path d="M0 100 Q180 65 360 100 Q540 135 720 100 Q900 65 1080 100 Q1260 135 1440 100 L1440 180 L0 180 Z" fill="#06b6d4" opacity="0.12"/>
      <path d="M0 125 Q180 95 360 125 Q540 155 720 125 Q900 95 1080 125 Q1260 155 1440 125 L1440 180 L0 180 Z" fill="#22d3ee" opacity="0.08"/>
    </svg>
  </Box>
);
